import { passwordLogin } from "@ueni/users-api";
import { AxiosError } from "axios";
import { useCallback } from "react";
import { useParams } from "react-router";
import { eventsV2 } from "../../../constants/eventsV2";
import { useAfterLogin } from "../../../hooks/useAfterLogin";
import { useErrorHandling } from "../../../hooks/useErrorHandling";
import { loginSchema as validationSchema } from "../../../schema";
import api from "../../../services/api";
import { sendEvent } from "../../../utils/analytics/sendEvent";

interface FormValues {
  email: string;
  password: string;
}

export const useLoginPasswordPage = () => {
  const locale = useParams()["locale"];
  const { handleApiError } = useErrorHandling();
  const afterLogin = useAfterLogin();
  const initialValues: FormValues = {
    email: "",
    password: "",
  };

  const onPasswordLogin = useCallback(
    async (payload, actions) => {
      const label = "email";
      sendEvent(eventsV2.login.buttonClicked({ label }));
      try {
        const { data } = await passwordLogin(api, payload);
        return afterLogin(data, label);
      } catch (e) {
        sendEvent(eventsV2.login.failure({ label }));
        handleApiError(e as AxiosError, actions);
        return;
      }
    },
    [afterLogin]
  );

  const sendSignUpClickEvent = useCallback(() => sendEvent(eventsV2.login.createAccount({ label: "???" })), []);
  const sendForgotClickEvent = useCallback(
    () => sendEvent(eventsV2.login.forgotPasswordClicked({ label: locale })),
    [locale]
  );

  return {
    locale,
    initialValues,
    validationSchema,
    onPasswordLogin,
    sendSignUpClickEvent,
    sendForgotClickEvent,
  };
};
